export default __webpack_public_path__ + "images/e05cef320519b00335b9cec3e1d88abe-pride_touchpoint_image_mobile.webp";